import { Alert, Button, Divider, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ModelPage from "../../../../../layout/ModelPage";
import { notification } from "../../../../../context/actions/notificationActions";
import { startCrearConcesionadosConDocumentos } from "../../../../../context/actions/pagos2Actions";
import { composeErrorNotification } from "../../../../../utils/composeNotification";

export default function ModalCargaConcesionados({
  visible,
  onClose,
  asistencias = [],
  loading,
  setLoading,
  onSuccess,
}) {
  const dispatch = useDispatch();
  const { usuarioID } = useSelector((state) => state.userReducer.user);
  const [body, setBody] = useState({});

  const estaVacioNull = (valor) => {
    if (valor === "" || valor === null || valor === undefined) {
      return true;
    }
    return false;
  };

  const camposError = () => {
    let salida = false;
    if (estaVacioNull(body.facturaPDF)) salida = true;
    if (estaVacioNull(body.facturaXML)) salida = true;
    if (estaVacioNull(body.verificacionFactura)) salida = true;
    return salida;
  };

  const props1 = {
    beforeUpload: (facturaPDF) => {
      setBody({ ...body, facturaPDF });
      return false;
    },
    maxCount: 1,
    showUploadList: false,
  };

  const props2 = {
    beforeUpload: (facturaXML) => {
      setBody({ ...body, facturaXML });
      return false;
    },
    maxCount: 1,
    showUploadList: false,
  };

  const props3 = {
    beforeUpload: (verificacionFactura) => {
      setBody({ ...body, verificacionFactura });
      return false;
    },
    maxCount: 1,
    showUploadList: false,
  };

   const handleClick = async () => {
     if (camposError()) {
       dispatch(
         notification(
           composeErrorNotification("Error", "Todos los archivos son requeridos")
         )
       );
       return;
     }

     setLoading(true);

     try {
       let formdata = new FormData();

       formdata.append("FacturaPDF", body.facturaPDF);
       formdata.append("FacturaXML", body.facturaXML);
       formdata.append("VerificacionFactura", body.verificacionFactura);
       formdata.append("UsuarioID", usuarioID);

       const asistenciasIds = asistencias.map((a) => a.asistenciaID).join(",");
       formdata.append("Asistencias", asistenciasIds);

       const result = await dispatch(
         startCrearConcesionadosConDocumentos(formdata)
       );

       if (result.success) {
         setBody({});
         if (onSuccess) {
           await onSuccess(result.data);
         } else {
           onClose();
         }
       }
     } finally {
       setLoading(false);
     }
   };

  const ok = () => {
    handleClick();
  };

  const cancel = () => {
    setBody({});
    onClose();
  };

  return (
    <ModelPage
      titulo="Concesionados - Cargar Factura"
      isVisible={visible}
      handleOk={ok}
      handleCancel={cancel}
      confirmLoading={loading}
      className="pagos-v2-modal"
      width={350}
    >
      <div style={{ textAlign: "center" }}>
        <div className="tituloPequeño">Factura PDF emitida por el proveedor</div>

        <Upload {...props1} style={{ width: "100%" }}>
          <Button style={{ marginTop: 20 }} icon={<UploadOutlined />}>
            Seleccione documento
          </Button>
        </Upload>
        <div style={{ marginTop: 8 }}>{body.facturaPDF?.name}</div>

        <Divider />
        <div className="tituloPequeño">Factura XML emitida por el proveedor</div>

        <Upload {...props2} style={{ width: "100%" }}>
          <Button style={{ marginTop: 20 }} icon={<UploadOutlined />}>
            Seleccione documento
          </Button>
        </Upload>
        <div style={{ marginTop: 8 }}>{body.facturaXML?.name}</div>

        <Divider />
        <div className="tituloPequeño">Verificacion de factura por SAT</div>
        <div style={{ marginTop: 8, display: "inline-block" }}>
          <Alert
            type="warning"
            showIcon
            style={{ fontSize: "11px" }}
            message={"Por favor verifica que los folios fiscales coincidan"}
          />
        </div>

        <Upload {...props3} style={{ width: "100%" }}>
          <Button style={{ marginTop: 20 }} icon={<UploadOutlined />}>
            Seleccione documento
          </Button>
        </Upload>
        <div style={{ marginTop: 8 }}>{body.verificacionFactura?.name}</div>
      </div>
    </ModelPage>
  );
}
